<template>
  <div>
    <h3 class="modal-title"> WORKFLOW APPROVER </h3>

    <b-form-group :class="{'error-input' : $v.data_approver.title.$error}">
      <label> Workflow Approver Title </label>
      <j-input
        v-model="$v.data_approver.title.$model"
        :max-length="255"
        placeholder="Workflow Approver Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_approver.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_approver.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Choose Form'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeApprover">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveApprover">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_approver: {
      title: {
        required,
      },
      form: {
        required,
      },
    },
  },
  data() {
    return {
      data_approver: {
        title: '',
        form: null,
      },
    };
  },
  computed: {
    generateDataApprover() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_approver.form.id,
        }),
        value_id: `${this.data_approver.form.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_approver.title,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },

    generateDataApproverUpdate() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_approver.form.id,
        }),
        value_id: `${this.data_approver.form.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_approver.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  async mounted() {
    if (this.modeEdit) {
      const formDetail = await this.getDetailForm({
        additional_info_block: {
          id: Number(JSON.parse(this.dataEdit.info).form_id),
        },
      });
      this.data_approver.form = {
        id: formDetail.id,
        name: formDetail.name,
        label: formDetail.name,
      };

      this.data_approver.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm']),

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveApprover() {
      this.$v.data_approver.$touch();
      if (!this.$v.data_approver.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataApprover,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataApproverUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeApprover();
      }
    },

    closeApprover() {
      this.$emit('close-field');
      this.data_approver.title = '';
      this.data_approver.form = null;
      setTimeout(() => {
        this.$v.data_approver.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jWorkflowAppSetup.vue